import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource, MatPaginator, MatDialog } from "@angular/material";
import { StudentService } from "src/app/services/http/business/student/student.service";
import { CourseDetailsComponent } from "../course-details/course-details.component";
import { SubmitSurveyComponent } from "../submit-survey/submit-survey.component";
import { RegistrationHistoryReportComponent } from "../registration-history-report/registration-history-report.component";
import { SessionListComponent } from "../session-list/session-list.component";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-register-courses',
  templateUrl: './register-courses.component.html',
  styleUrls: ['./register-courses.component.css']
})
export class RegisterCoursesComponent implements OnInit {

  dataSource = new MatTableDataSource();
  userInfo: any;

  reportUrl = environment.ReportBaseUrl;

  displayedColumns: string[] = [
    "company",
    "courseLevel",
    "coursePattern",
    "termInfo",
    "teacherName",
    "payment",
    "discountedPrice",
    "date",
    "score",
    "status",
    "registerStatus",
    "function"
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    public translate: TranslateService,
    private studentService: StudentService,
  ) { }

  ngOnInit() {
    this.refresh();
  }

  //open modal from show details
  details(data: any) {
    this.dialog.open(CourseDetailsComponent, {
      width: '550px',
      data: data,
      disableClose: true
    })
      .afterClosed()
      .subscribe(() => {
        this.refresh();
      });
  }

  //open modal from  submit Survey
  submitSurvey(params: any) {
    this.dialog.open(SubmitSurveyComponent, {
      width: '90%',
      height: "80%",
      data: params,
      disableClose: true
    })
      .afterClosed()
      .subscribe(() => {

        this.refresh();
      });
  }

  getColor(isPassed: any) {
    switch (isPassed) {
      case true:
        return "custom-chips success";
      case false:
        return "custom-chips accent";
      default:
        return "custom-chips default";
    }
  }

  getLabel(isPassed: any) {
    switch (isPassed) {
      case true:
        return "label.accepted";
      case false:
        return "label.rejected";
      default:
        return "label.unknown";
    }
  }

  refresh() {
    this.studentService.getRegistrationCourses(1, 10).subscribe(res => {
      this.dataSource = null;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  paginatorEvent(event) {
    this.studentService.getRegistrationCourses(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  showHistory() {
    this.dialog.open(RegistrationHistoryReportComponent, {
      width: "90%",
      data: this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    });
  }

  sessions(course: any) {
    this.dialog.open(SessionListComponent, {
      width: "800px",
      data: course
    })
  }

}
